const STORAGE_KEY = 'trinity.supportAccess.token';

export const getSupportAccessToken = (): string | null => {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const saveSupportAccessToken = (token: string): void => {
  sessionStorage.setItem(STORAGE_KEY, token);
};

export const clearSupportAccessToken = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable.
  }
};
